module.exports = new __parcel__URL__("report-version-workload.f7f86d40.svg").toString();